import React from 'react'
import { ListItemButton } from '@mui/material'
import { Dashboard as DashboardIcon } from '@mui/icons-material'
import { useActAsUsersList } from '@edge/spark/io-roles'
import { AdminAuctionUserDashboards } from '../../../../spark_libs_deprecated/feature-dashboards'
import StyledDivider from './StyledDivider'

interface AdminActAsUserProps {
    expanded: boolean
}

export const AdminActAsUser: React.VFC<AdminActAsUserProps> = ({ expanded }: AdminActAsUserProps) => {
    const usersList = useActAsUsersList()

    if (!usersList.length) {
        return null
    }

    return (
        <>
            {expanded ? (
                <AdminAuctionUserDashboards users={usersList} />
            ) : (
                <ListItemButton sx={{ paddingLeft: '20px', height: 56, color: '#888' }}>
                    <DashboardIcon />
                </ListItemButton>
            )}

            <StyledDivider />
        </>
    )
}

export default AdminActAsUser
